import script from "./Timestamp.vue?vue&type=script&setup=true&lang=js"
export * from "./Timestamp.vue?vue&type=script&setup=true&lang=js"

import "./Timestamp.vue?vue&type=style&index=0&id=209d8083&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-209d8083"]])

export default __exports__